<!--=================================
 preloader -->
<div id="pre-loader" *ngIf="commondata.loader.value">
    <img src="assets/images/pre-loader/loader-01.svg" alt="">
</div>
<div class="page-wrapper auth-bg">
    <div class="authentication-box-web">

        <section class="container" style="display: block" *ngIf="!type">
            <div class="row">
                <div class="col-12 col-md-5 p-0 card-left">
                    <div class="card bg-primary mb-0">
                        <div class="svg-icon d-flex justify-content-center" style="min-height: 15rem">
                            <img alt="" class="my-2" src="assets/images/{{logo}}" style="height: auto; object-fit: fill">
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-7 p-0 mt-2 card-right">
                    <div class="card tab2-card p-4">
                        <div class="card-body">
                            <h4 class="login-text">Login To {{siteName}}</h4>

                            <div class="d-flex justify-content-center google-sign">
                                <div class="col-6">

                                    <div id="g_id_onload"
                                         data-client_id="854159816646-f2oidr960elk0akcu27dddb9dveoj9r3.apps.googleusercontent.com"
                                         data-context="use"
                                         data-ux_mode="popup"
                                         [attr.data-login_uri]="backEndURLSignIn"
                                         data-auto_prompt="false">
                                    </div>

                                    <div class="g_id_signin"
                                         data-type="standard"
                                         data-shape="rectangular"
                                         data-theme="outline"
                                         data-text="signin_with"
                                         data-size="large"
                                         data-logo_alignment="left">
                                    </div>
                                </div>
                            </div>

                            <div class="tp-login-mail text-center my-4"><p>or Sign in with Email</p></div>

                            <div class="tab-pane fade active show" id="account" role="tabpanel"
                                 aria-labelledby="account-tab">
                                <form [formGroup]="loginForm"
                                      class="form-horizontal auth-form1" novalidate="">
                                    <div class="form-group">
                                        <input autofocus required="true" formControlName="userName" name="login[username]" type="email"
                                               class="form-control" placeholder="Username"
                                               id="exampleInputEmail1">
                                        <em class="error" *ngIf="!loginForm.get('userName').valid && (loginForm.get('userName').dirty || loginForm.get('userName').touched)">User name is required</em>
                                    </div>
                                    <div class="form-group">
                                        <div class="input-group">
                                            <input required="true"  name="login[password]" type="text" formControlName="password"
                                                   class="form-control" placeholder="Password" aria-label="Recipient's username" aria-describedby="basic-addon1" [type]="conps ? 'password' : 'text'">
                                            <div class="input-group-append cursor" (click)="conps = !conps">
                                                <span class="input-group-text" id="basic-addon3">
                                                    <i [class]="conps ? 'fa fa-eye-slash' : 'fa fa-eye'" aria-hidden="true"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <em class="error" *ngIf="!loginForm.get('password').valid && (loginForm.get('password').dirty || loginForm.get('password').touched)">Password is required</em>
                                    </div>
                                    <div class="form-terms">
                                        <div class="custom-control custom-checkbox mr-sm-2">
                                            <input type="checkbox" class="custom-control-input cursor" formControlName="checkbox"
                                                   id="customControlAutosizing">
                                            <label class="custom-control-label"
                                                   for="customControlAutosizing">Remember me</label>
                                            <a [routerLink]="'/forgotPassword/content'"
                                               class="btn btn-default forgot-pass italic_text">Forgot
                                                password</a>
                                        </div>
                                    </div>
                                    <div class="form-button align-items-center justify-content-end d-flex mt-3">
                                        <button class="btn btn-primary mb-1 w-100">Login<i class="ml-2 fa fa-long-arrow-right fa-1x" aria-hidden="true"></i></button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
<ng-template #tcupdate let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Terms & Conditions and Privacy Policy</h4>
    </div>
    <div class="modal-body">
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <input type="checkbox" class="form-check-input text-center" [(ngModel)]="checkterms" ><span>I accept </span><a href="https://edquill.com/terms_and_conditions.html" target="_blank"><span style="font-style: italic; text-decoration: underline;">Terms & Conditions</span></a> <span> and </span> <a href="https://edquill.com/privacy_policy.html" target="_blank" style="font-style: italic; text-decoration: underline;">Privacy Policy</a>
                </div>
            </div>
        </div>

        <!-- Container-fluid Ends-->

    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" (click)="confirmtermDetails()" [disabled]="checkterms == undefined || !checkterms">Submit</button>
    </div>
</ng-template>
